import React from "react"
import NoBodyStyles from "./body.less"
import {connect} from "react-redux"

// eslint-disable-next-line react/prefer-stateless-function
export class NoDataBody extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <div className={NoBodyStyles.noDataBody}>
                <div className={NoBodyStyles.startAndErrorPic}>
                    <div className={NoBodyStyles.showPicImgBox}>
                        <img className={NoBodyStyles.showPic} src={this.props.showPic} />
                    </div>
                    <p className={NoBodyStyles.showTip}>{this.props.showTip}</p>
                </div>
            </div>
        )
    }
}
export default connect((state: any) => {
    return {
        errorMessage: state.errorMessage,
        showPic: state.showPic,
        showTip: state.showTip,
    }
})(NoDataBody)
